// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3_XX7","title":"BackImages_title__eDHjp","images":"BackImages_images__3Q2Jy"};